import React from 'react';
import { Card, CardContent } from "../../tailwind/card";
import { Activity, TrendingUp } from "lucide-react";

export const HealthScore = ({ score = 98 }) => {
  return (
    <Card className="border-emerald-100 dark:border-emerald-900 bg-emerald-50/50 dark:bg-emerald-900/10">
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-emerald-900 dark:text-emerald-100">Overall Health</h3>
          <Activity className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
        </div>
        
        <div className="flex items-end gap-2">
          <span className="text-4xl font-bold text-emerald-900 dark:text-white">{score}%</span>
          <span className="text-sm font-medium text-emerald-600 dark:text-emerald-400 mb-1">Excellent</span>
        </div>
        
        <div className="mt-4 flex items-center gap-2 text-xs text-emerald-700 dark:text-emerald-300 bg-white/50 dark:bg-black/20 p-2 rounded-lg">
          <TrendingUp className="h-3 w-3" />
          <span>Top 5% of business accounts</span>
        </div>
      </CardContent>
    </Card>
  );
};